import { Injectable, Inject } from '@angular/core';
import { AbstractDataProvider } from '../AbstractDataProvider';
import { Subject } from 'rxjs';

@Injectable()
export class UiComponentService {

  public listOfCachedCodes: Array<{ CodeType: string, CodeValues: any }> = [];
  public listOfCallMadePerCodeType: Array<{ CodeType: string, isCalled: boolean, subjectForIt: Subject<any> }> = [];
  subjectsListForCodeType;
  uiComponentCounter = 1;

  constructor(public abstractDataProvider: AbstractDataProvider) {

  }
}
